const { LIST_PER_PAGE } = process.env;



// eslint-disable-next-line no-restricted-globals
export const PerPage = LIST_PER_PAGE || 10;

export const Role = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  // RESELLER: 3,
  SUPERWISER: 4,
  TEAMLEAD: 5,
  OTHER: 6,
}

export const superAdminAccess = [Role.SUPER_ADMIN]
export const userAccess = [Role.SUPER_ADMIN, Role.ADMIN];

export const agentAccess = [Role.SUPER_ADMIN, Role.ADMIN, Role.SUPERWISER, Role.TEAMLEAD];
export const otherUser = [Role.OTHER];
export const teamleaderAccess = [Role.TEAMLEAD];

// userAccess.includes(currentUser.role) &&


// WEBPACK FOOTER //
// ./src/helpers/system-config.js